// Product data for Geyser PRO Lead Generation Landing Page

export const products = [
  {
    id: 1,
    name: "KIT Geyser 2 L - 10 mq",
    label: "Per balconi e terrazzi",
    coverage: 10,
    price: 63,
    originalPrice: 73,
    image: "/calcola-preventivo/geyser_44001.jpg",
    description: "Geyser Nebulizzatore 2 L Li-Ion. Nebulizzazione ultra-fine per trattamenti antizanzare.",
    bullets: [
      "Ideale per balconi e terrazzi",
      "Copertura estendibile fino a 20 m\u00B2",
      "Batteria Li-Ion inclusa"
    ]
  },
  {
    id: 2,
    name: "KIT Geyser 4 L - 40 mq",
    label: "Per giardini piccoli",
    coverage: 40,
    price: 253,
    originalPrice: 303,
    image: "/calcola-preventivo/geyser_43701.jpg",
    description: "Geyser Nebulizzatore 4 L Li-Ion. Nebulizzazione ultra-fine per trattamenti antizanzare.",
    bullets: [
      "Per giardini piccoli",
      "Copertura estendibile fino a 200 m\u00B2",
      "Cappuccio protettivo incluso"
    ]
  },
  {
    id: 3,
    name: "KIT Geyser 12 L - 40 mq",
    label: "Per giardini piccoli-medi",
    coverage: 40,
    price: 342,
    originalPrice: 407,
    image: "/calcola-preventivo/geyser_43801.jpg",
    description: "Geyser Nebulizzatore 12 L Li-Ion. Nebulizzazione ultra-fine con treppiede incluso.",
    bullets: [
      "Copertura estendibile fino a 200 m\u00B2",
      "Treppiede incluso",
      "Trattamenti prolungati"
    ]
  },
  {
    id: 4,
    name: "KIT Geyser 25 L - 400 mq",
    label: "Per giardini medi",
    coverage: 400,
    price: 659,
    originalPrice: 775,
    image: "/calcola-preventivo/geyser_43901.jpg",
    description: "Geyser Nebulizzatore 25 L MI 21V. Batteria Power 21V inclusa.",
    bullets: [
      "Giardini medi fino a 400 m\u00B2",
      "Batteria Power 21V 2,6 Ah inclusa",
      "Caricabatterie doppio 21V incluso"
    ]
  },
  {
    id: 5,
    name: "KIT Geyser PRO Lite - 650 mq",
    label: "Per giardini grandi",
    coverage: 650,
    price: 1657,
    originalPrice: 1787,
    image: "/calcola-preventivo/geyser_43601.jpg",
    description: "Nebulizzazione ultra-fine per trattamenti antizanzare, automatizzati e ad intervalli.",
    bullets: [
      "Sistema professionale automatizzato",
      "Alimentatore AC 220V incluso",
      "Cappuccio protettivo omaggio"
    ]
  },
  {
    id: 6,
    name: "KIT Geyser PRO - 970 mq",
    label: "Per grandi proprietà",
    coverage: 970,
    price: 2219,
    originalPrice: 2389,
    image: "/calcola-preventivo/geyser_41502.jpg",
    description: "Sistema professionale avanzato. Copertura estendibile fino a 3.600 m\u00B2.",
    bullets: [
      "Copertura estendibile fino a 3.600 m\u00B2",
      "Alimentatore AC 220V incluso",
      "Cappuccio protettivo omaggio"
    ]
  },
  {
    id: 7,
    name: "KIT Geyser PRO - 1.400 mq",
    label: "Per parchi e grandi giardini",
    coverage: 1400,
    price: 2281,
    originalPrice: 2458,
    image: "/calcola-preventivo/geyser_41501.jpg",
    description: "Sistema professionale per grandi aree. Copertura estendibile fino a 3.600 m\u00B2.",
    bullets: [
      "Copertura estendibile fino a 3.600 m\u00B2",
      "Alimentatore AC 220V incluso",
      "Cappuccio protettivo omaggio"
    ]
  },
  {
    id: 8,
    name: "KIT Geyser PRO Dual - 3.900 mq",
    label: "Per uso professionale / grandi superfici",
    coverage: 3900,
    price: 2602,
    originalPrice: 2806,
    image: "/calcola-preventivo/geyser_44602.jpg",
    description: "2 uscite, protezione antizanzare in 2 zone diverse (1.950 + 1.950 m\u00B2).",
    bullets: [
      "Sistema doppio \u2014 2 zone",
      "Copertura estendibile fino a 7.200 m\u00B2",
      "Cappuccio protettivo omaggio"
    ]
  },
  {
    id: 9,
    name: "KIT Geyser PRO Dual - 7.200 mq",
    label: "Per campeggi e resort",
    coverage: 7200,
    price: 3059,
    originalPrice: 3318,
    image: "/calcola-preventivo/geyser_44601.jpg",
    description: "2 uscite, protezione antizanzare in 2 zone diverse (3.600 + 3.600 m\u00B2).",
    bullets: [
      "Massima potenza \u2014 2 zone",
      "Copertura 7.200 m\u00B2 non estendibile",
      "Cappuccio protettivo omaggio"
    ]
  }
];

export const provinces = [
  "Agrigento", "Alessandria", "Ancona", "Aosta", "Arezzo", "Ascoli Piceno", "Asti",
  "Avellino", "Bari", "Barletta-Andria-Trani", "Belluno", "Benevento", "Bergamo",
  "Biella", "Bologna", "Bolzano", "Brescia", "Brindisi", "Cagliari", "Caltanissetta",
  "Campobasso", "Caserta", "Catania", "Catanzaro", "Chieti", "Como", "Cosenza",
  "Cremona", "Crotone", "Cuneo", "Enna", "Fermo", "Ferrara", "Firenze", "Foggia",
  "Forlì-Cesena", "Frosinone", "Genova", "Gorizia", "Grosseto", "Imperia", "Isernia",
  "L'Aquila", "La Spezia", "Latina", "Lecce", "Lecco", "Livorno", "Lodi", "Lucca",
  "Macerata", "Mantova", "Massa-Carrara", "Matera", "Messina", "Milano", "Modena",
  "Monza e Brianza", "Napoli", "Novara", "Nuoro", "Oristano", "Padova", "Palermo",
  "Parma", "Pavia", "Perugia", "Pesaro e Urbino", "Pescara", "Piacenza", "Pisa",
  "Pistoia", "Pordenone", "Potenza", "Prato", "Ragusa", "Ravenna", "Reggio Calabria",
  "Reggio nell'Emilia", "Rieti", "Rimini", "Roma", "Rovigo", "Salerno", "Sassari",
  "Savona", "Siena", "Siracusa", "Sondrio", "Sud Sardegna", "Taranto", "Teramo",
  "Terni", "Torino", "Trapani", "Trento", "Treviso", "Trieste", "Udine", "Varese",
  "Venezia", "Verbano-Cusio-Ossola", "Vercelli", "Verona", "Vibo Valentia", "Vicenza", "Viterbo"
];
